import axios from "axios";
import { shouldSendSessionActivityHeader } from "utils/sessionActivity";

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_BASE_URL ||
    (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001"),
  withCredentials: true, // IMPORTANT for cookie auth
});

instance.interceptors.request.use((config) => {
  if (shouldSendSessionActivityHeader()) {
    config.headers = config.headers || {};
    config.headers["X-Session-Activity"] = "1";
  }
  return config;
});

export default instance;
